let musicDB = [
    {
        id: 0,
        name: "LemonTree",
        author_name: "Gustixa",
        img: "LemonTree.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type: "electronic",
        musicName: "Gustixa - lemon tree.mp3",
        attribution: {
            song: "Gustixa - lemon tree.mp3",
            musicBy: "NoCopyrightSounds",
            download: "https://downloadlagu321.net/dl/MunnYFmqWYo",
            stream: "https://www.youtube.com/watch?v=MunnYFmqWYo"
        }
    },
    {
        id: 1,
        name: "PlayDate",
        author_name: "Gustixa",
        img: "PlayDate.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type:"remix",
        musicName: "Gustixa - play date (lofi remix) LYRICS.mp3",
        attribution: {
            song: "Gustixa - play date (lofi remix) LYRICS.mp3",
            musicBy: "Gustixa",
            download: null,
            stream: "https://www.youtube.com/watch?v=dVzNXEOfHNs"
        }
    },
    {
        id: 2,
        name: "Falling in love",
        author_name: " Gustixa",
        img: "fallinginlove.jpg",
        lang: "ENGLISH",
        type: "remix",
        timesPlayed: 0,
        musicName: "Gustixa - falling in love (ft. Yara Fabricante).mp3",
        attribution: {
            song: "Gustixa - falling in love (ft. Yara Fabricante).mp3",
            musicBy: "Gustixa",
            download: "https://downloadlagu321.net/dl/MunnYFmqWYo",
            stream: null
        }
    },
    {
        id: 3,
        name: "Hindia - Secukupnya",
        author_name: "Hindia",
        img: "hindia.jpg",
        lang: "Indonesia",
        timesPlayed: 0,
        type: "indie",
        musicName: "Hindia - Secukupnya (Lyric Video) - OST. Nanti Kita Cerita Tentang Hari Ini.mp3",
        attribution: {
            song: "Hindia - Secukupnya (Lyric Video) - OST. Nanti Kita Cerita Tentang Hari Ini.mp3",
            musicBy: "NoCopyrightSounds",
            download: null,
            stream: null
        }
    },
    {
        id: 4,
        name: "Death Bed",
        author_name: "Gustixa",
        img: "DeathBed.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type: "remix",
        musicName: "(DownloadLagu321.Net) Gustixa Death Bed ft Shalom Margaret.mp3",
        attribution: {
            song: "(DownloadLagu321.Net) Gustixa Death Bed ft Shalom Margaret.mp3",
            musicBy: "Gustixa",
            download: "http://ncs.io/Apocalypse",
            stream: "http://youtu.be/Whw1sWDpAvE"
        }
    },
    {
        id: 5,
        name: "Happy-Gustixa ft Nida Havia",
        author_name: "Gustixa",
        img: "Happy.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type: "electronic",
        musicName: "happy (Gustixa ft. Nida Havia).mp3",
        attribution: {
            song: "happy (Gustixa ft. Nida Havia).mp3",
            musicBy: "Skinnyfabs",
            download: null,
            stream: null
        }
    },
    {
        id: 6,
        name: "Past Live",
        author_name: "Gustixa-Remix",
        img: "Pastlive.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type:"remix",
        musicName: "Gustixa - past lives remix.mp3",
        attribution: {
            song: "Gustixa - past lives remix.mp3",
            musicBy: "Gustixa",
            download: null,
            stream: null
        }
    },
    {
        id: 7,
        name: "Bitter Love",
        author_name: "ardhito pramono",
        img: "Bitterlove.png",
        lang: "ENGLISH",
        timesPlayed: 0,
        type:"jazz",
        musicName: "Ardhito Pramono - bitterlove (Official Video).mp3",
        attribution: {
            song: "Ardhito Pramono - bitterlove (Official Video).mp3",
            musicBy: "ardhito pramono",
            download: null,
            stream: null
        }
    },
    {
        id: 8,
        name: "One Only",
        author_name: "Pamungkas",
        img: "Oneonly.jpg",
        lang: "ENGLISH",
        timesPlayed: 0,
        type: "jazz",
        musicName: "Pamungkas - One Only (Lyrics Video).mp3",
        attribution: {
            song: "Pamungkas - One Only (Lyrics Video).mp3",
            musicBy: "Pamungkas",
            download: null,
            stream: null
        }
    },
    {
      id: 9,
      name: "Kenangan Manis",
      author_name: "Pamungkas",
      img: "Pamungkas - Kenangan Manis.jpg",
      lang: "Indonesia",
      timesPlayed: 0,
      type: "jazz",
      musicName: "Pamungkas - Kenangan Manis (Lyrics Video).mp3",
      attribution: {
          song: "Pamungkas - Kenangan Manis (Lyrics Video).mp3",
          musicBy: "Pamungkas",
          download: null,
          stream: null
      }
  },
  {
    id: 10,
    name: "Sesuatu Di Jogja - Adhitia Sofyan",
    author_name: "Adhitia Sofyan",
    img: "sesuatudijogja.jpg",
    lang: "Indonesia",
    timesPlayed: 0,
    type: "indie",
    musicName: "Sesuatu Di Jogja - Adhitia Sofyan (official audio).mp3",
    attribution: {
        song: "Sesuatu Di Jogja - Adhitia Sofyan (official audio).mp3",
        musicBy: "Adhitia Sofyan",
        download: null,
        stream: "https://www.youtube.com/watch?v=l2mI4vL95kU"
    }
},
{
  id: 10,
  name: "Fallen Kingdom ",
  author_name: "Gustixa",
  img: "Fallenkingdom.jpg",
  lang: "ENGLISH",
  timesPlayed: 0,
  type: "remix",
  musicName: "fallen kingdom (Gustixa Remix).mp3",
  attribution: {
      song: "fallen kingdom (Gustixa Remix).mp3",
      musicBy: "Gustixa",
      download: null,
      stream: null
  }
},
{
  id: 11,
  name: "Enau - Negara Lucu (Acoustic)",
  author_name: "Enau",
  img: "negaralucu.jpg",
  lang: "Indonesia",
  timesPlayed: 0,
  type: "indie",
  musicName: "eńau - Negara Lucu ACOUSTIC SESSION (at Conclave Wijaya).mp3",
  attribution: {
      song: "eńau - Negara Lucu ACOUSTIC SESSION (at Conclave Wijaya).mp3",
      musicBy: "Enau",
      download: null,
      stream: "https://www.youtube.com/watch?v=FD2sUO3ql8k"
  }
}

];

export default musicDB;
/*let musicDB = [
  {
    id:0,
    name:"Left Foot Up Right Foot Slide",
    author_name: "Yung Nazty",
    img: "left_foot_up_right_foot_slide.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"left_foot_up_right_foot_slide.mp3"
  },
  {
    id:1,
    name: "Intentions (feat. Quavo)",
    author_name: "Justin Bieber",
    img: "intentions.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"intentions.mp3"
  },
  {
    id:2,
    name: "Naina Da Kya Kasoor",
    author_name: "Amit Trivedi",
    img: "naina_da_kya_kasoor.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"Naina_da_kya_kasoor.mp3"
  },
  {
    id:3,
    name: "Señorita",
    author_name: "Shawn Mendes",
    img: "senorita.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"senorita.mp3"
  },
  {
    id:4,
    name: "Memories",
    author_name: "Maroon 5",
    img: "memories.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"memories.mp3"
  },
  {
    id:5,
    name: "Skechers",
    author_name: "DripReport",
    img: "skechers.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"Skechers.mp3"
  },
  {
    id:6,
    name: "Sunflower - Spider-Man: Into the Spider-Verse",
    author_name: "Post Malone",
    img: "sunflower.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"Sunflower.mp3"
  },
  {
    id:7,
    name: "I Can’t Get Enough",
    author_name: "benny blanco, Selena Gomez, J Balvin, Tainy",
    img: "i_cant_get_enough.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"i_cant_get_enough.mp3"
  },
  {
    id:8,
    name: "Old Town Road",
    author_name: "Lil Nas X",
    img: "old_town_road.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"old_town_road.mp3"
  },
  {
    id:9,
    name: "Beautiful Stillness",
    author_name: "Billy-Joe",
    img: "beautiful_stillness.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"Beautiful_Stillness.mp3"
  },
  {
    id:10,
    name: "death bed (coffee for your head)",
    author_name: "Powfu",
    img: "death_bed.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"death_bed.mp3"
  },
  {
    id:11,
    name: "Halka Halka (From \"Fanney Khan\")",
    author_name: "Sunidhi Chauhan",
    img: "halka_halka_suroor.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"halka_halka_suroor.mp3"
  },
  {
    id:12,
    name: "Kudi Nu Nachne De (From \"Angrezi Medium\")",
    author_name: "Vishal Dadlani",
    img: "kudi_nu_nachne_de.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"kudi_nu_nachne_de.mp3"
  },
  {
    id:13,
    name: "Illegal Weapon 2.0",
    author_name: "Jasmine Sandlas",
    img: "illeagal_weapon_2.jpg",
    lang:"PUBJABI",
    timesPlayed:0,
    musicName:"illeagal_weapon_2.mp3"
  },
  {
    id:14,
    name: "Genda Phool (feat. Payal Dev)",
    author_name: "Badshah",
    img: "genda_phool.jpg",
    lang:"BENGALI",
    timesPlayed:0,
    musicName:"genda_phool.mp3"
  },
  {
    id:15,
    name: "Yaar Mod Do",
    author_name: "Guru Randhawa",
    img: "yaar_mod_do.jpg",
    lang:"PUNJABI",
    timesPlayed:0,
    musicName:"yaar_mod_do.mp3"
  },
  {
    id:16,
    name: "Shayad",
    author_name: "Pritam",
    img: "shayad.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"shayad.mp3"
  },
  {
    id:17,
    name: "Without Me",
    author_name: "Halsey",
    img: "without_me.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"without_me.mp3"
  },
  {
    id:18,
    name: "Buttabomma - Telugu",
    author_name: "Armaan Malik",
    img: "buttabomma.jpg",
    lang:"TELUGU",
    timesPlayed:0,
    musicName:"ButtaBomma.mp3"
  },
  {
    id:19,
    name: "Coda",
    author_name: "Jakob Ahlbom",
    img: "coda.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"coda.mp3"
  },
  {
    id:20,
    name: "Khairiyat",
    author_name: "Arijit Singh",
    img: "khairiyat.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"khairiyat.mp3"
  },
  {
    id:21,
    name: "Haan Main Galat",
    author_name: "Pritam",
    img: "haan_mai_galat.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"haan_mai_galat.mp3"
  },
  {
    id:22,
    name: "Mere Liye Tum Kaafi Ho (From \"Shubh Mangal Zyada Saavdhan\")",
    author_name: "Ayushmann Khurrana",
    img: "mere_liiye_tum_kaafi_ho.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"mere_liiye_tum_kaafi_ho.mp3"
  },
  {
    id:23,
    name: "Fracture",
    author_name: "Jakob Ahlbom",
    img: "fracture.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"fracture.mp3"
  },
  {
    id:24,
    name: "Ghungroo (From \"War\")",
    author_name: "Arijit Singh",
    img: "ghungroo.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"ghungroo.mp3"
  },
  {
    id:25,
    name: "Happier",
    author_name: "Marshmello",
    img: "happier.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"happier.mp3"
  },
  {
    id:26,
    name: "Namo Namo",
    author_name: "Amit Trivedi",
    img: "namo_namo.jpg",
    lang:"HINDI",
    timesPlayed:0,
    musicName:"namo_namo.mp3"
  },
  {
    id:27,
    name: "Faded",
    author_name: "Alan Walker",
    img: "faded.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"Faded_Alan_Walker.mp3"
  },
  {
    id:28,
    name: "I Don't Care (with Justin Bieber)",
    author_name: "Ed Sheeran",
    img: "i_dont_care.jpg",
    lang: "ENGLISH",
    timesPlayed:0,
    musicName:"i_dont_care.mp3"
  }
]
export default musicDB;*/